import * as CD from 'app/cd/models/essette-api';
import { ProviderService } from 'app/cd/services/provider-service';
import { apiCall } from 'app/shared/lib/api/api';
import { ComponentBase, StandardLoadOptions } from 'app/shared/lib/essette-site';
import { Toaster } from 'app/shared/lib/toaster';
import { autoinject } from 'aurelia-framework';
import { guid } from 'app/shared/lib/guid';

@autoinject()
export class ContactPage extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    protected locations: ReadonlyArray<CD.ProviderLocation> | null = null;

    protected includeInactive: boolean = false;

    protected id: guid = guid();


    ////****************** Element References ***************************************////



    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly providerService: ProviderService,
        private readonly toaster: Toaster,
        ...rest: any[]) {

        super(...rest);
        this.logger.source = this;
    }

    protected bind(bindingContext: Object, overrideContext: Object): void {
        this.loadLocations();
    }


    ////****************** Events ***************************************************////



    ////****************** Functions ************************************************////
    protected deactivateContact(): void {
        //TODO:
        this.toaster.info().message('Deactivate Contact not implemented').show();
    }


    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadLocations(): Promise<void> {
        const options: StandardLoadOptions = {
            all: true
        };
        const includes: string[] = [
            'facility'
        ];

        try {
            this.state.beginLoad();
            const response = await this.providerService.loadProviderLocationsBySession(options, includes);
            this.locations = response.results;
        }
        catch(error) {
            throw error;
        }
        finally {
            this.state.endLoad();
        }
    }
}
